import React from 'react'
import Header from '../../../../shared/sections/Header/index.tsx'
import FirstView from '../../../../shared/sections/FirstView/index.tsx'
import { zenkokuConfig } from '../../config.js'
import styles from './AllSpLandingPage.module.css'
import VerticalEntryForm from '../../../../shared/forms/VerticalEntryForm/index.tsx'
import { StepProvider } from '@/components/Context/StepContext'
import { AllSpLandingPageProps } from './types.ts'
import { useAbTestGtm } from '@/components/utils/abTest'
import Footer from '../../../../shared/sections/Footer/index.tsx'

export  default  function AllSpLandingPage ({ prefectures }: AllSpLandingPageProps) {
    const { dataViewLabel } = useAbTestGtm()

    return (
        <div className={styles.zenkokuSpLandingPage}>
            <StepProvider
                initialFormData={{
                    preferLineContact: true,
                    agreeTerms: true
                }}
                initialTouchedFields={{
                    preferLineContact: true,
                    agreeTerms: true,
                    channel: true
                }}
            >
                <Header
                    id='renewal_top'
                    dataViewLabel={dataViewLabel('HD')}
                />
                <FirstView dataViewLabel={dataViewLabel('CT_FirstView')}/>
                <VerticalEntryForm
                    prefectures={prefectures}
                    config={zenkokuConfig}
                />
                <Footer />
            </StepProvider>
        </div>
    )
}
